import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { PermitDetailsTransactionItemModel } from '../../services/permit.service';
import * as moment from 'moment';
import { } from 'googlemaps';
import * as $ from 'jquery';

@Component({
  selector: 'cli-logger-location-modal',
  templateUrl: './logger-location-modal.component.html',
  styleUrls: ['./logger-location-modal.component.scss']
})
export class LoggerLocationModalComponent implements OnInit {

  private subject: Subject<string>;

  @Input()
  public id: string;
  @Input()
  public header: string;
 

  private map: google.maps.Map;
  private marker: google.maps.Marker;
  private vm = new LoggerTransactionViewModel();


  @Input()
  public get transaction(): PermitDetailsTransactionItemModel { return this.vm.transaction; }
  public set transaction(value: PermitDetailsTransactionItemModel) {
    this.vm.transaction = value;
    
  }

  @ViewChild('ele1')
  private mapRef: ElementRef;

  constructor() {
  }

  ngOnInit() {
  }

  public showMarker(t: PermitDetailsTransactionItemModel) {
    let loc = { lat: t.latitude, lng: t.longitude };


    if (this.map == null) {

      let options = {
        center: new google.maps.LatLng(loc),
        zoom: 13,
        mapTypeId: google.maps.MapTypeId.ROADMAP,

      };

      this.map = new google.maps.Map(this.mapRef.nativeElement, options);
    }

    if (this.marker != null) {
      this.marker.setMap(null);
      this.marker = null;
    }
    
    this.marker = new google.maps.Marker({
      position: loc,
      map: this.map,
      title: t.regoNo + ' on ' + moment(t.fillDate).format('DD/MM/YYYY')
    });

    this.map.setCenter(loc);


  }


  public openModal(): Observable<string> {
    $('#' + this.id).modal();
    this.subject = new Subject<string>();

    if (!!this.vm.transaction) {
      this.showMarker(this.transaction);
    }

    return this.subject.asObservable();
  }

  public proceedYes() {

      this.closeModal();

      this.subject.next('Yes');
      this.subject.complete();
  }

  public proceedCancel() {

    this.closeModal();

    this.subject.next('Cancel');
    this.subject.complete();
  }

  public closeModal() {
    $('#' + this.id).modal('hide');
  }

}


class LoggerTransactionViewModel {
  public isLoading: boolean;
  public header: string;
  public transaction: PermitDetailsTransactionItemModel;
}
